import { createBrowserRouter } from 'react-router-dom';
import routesConfig from './routesConfig';

// eslint-disable-next-line import/prefer-default-export
export const router = createBrowserRouter(routesConfig);
